// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Cxwm","approved":"Status_approved__152G5","rejected":"Status_rejected__1I8C0","expired":"Status_expired__1oItd","label":"Status_label__JNsLw"};